import React from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import { ReviewsSort } from "rtr-constants";
import { userReviewSummaryPropType } from "components/propTypes";
import { isAdmin, userDataPropType, withUserData } from "components/source/hoc/with-user-data";
import { hasRented, withUserReviewSummary } from "components/layout/UserReviewSummaryContext";
import FitSummary from "./fit-summary";
import PropTypes from "prop-types";
import { onEnterPress } from "../../../helpers/a11y-helper";
import SizeFilter from "./size-filter";
import ReviewStars from "../shared/review-stars";
import ToolTipIcon from "../atoms/atom-tool-tip-icon";
import InfoIcon from "images/info-icon.svg";
import ReviewThumbNailCarousel from "../universal_pdp/reviews/review-thumbnail/review-thumbnail-carousel";
import { getSizeMap } from "components/source/universal_pdp/size-pills/helpers/size-selection-helper";

export class ReviewsHeaderComponent extends React.Component {
  static propTypes = {
    count: PropTypes.number,
    reviewsThumbnailPhotos: PropTypes.arrayOf(PropTypes.object),
    product: PropTypes.object,
    sort: PropTypes.string,
    styleName: PropTypes.string,
    summary: PropTypes.shape({
      averageStarRating: PropTypes.number,
      fitCounts: PropTypes.object,
    }).isRequired,
    triggerReviewModal: PropTypes.func,
    userData: userDataPropType,
    userReviewSummary: userReviewSummaryPropType,
    selectedSizes: PropTypes.array,
    filterReviewsBySize: PropTypes.func,
    sortReviews: PropTypes.func,
  };

  filters = [
    {
      label: "Featured",
      value: ReviewsSort.FEATURED,
    },
    {
      label: "Newest",
      value: ReviewsSort.NEWEST,
    },
    {
      label: "Rating",
      value: ReviewsSort.RATING,
    },
  ];

  showBanner() {
    const { styleName, userData, userReviewSummary } = this.props;

    return hasRented(userReviewSummary, styleName) || isAdmin(userData);
  }

  // TODO: Refactor this component to support reuse with the newer, simpler,
  // responsive review filter components
  render() {
    const { product, summary } = this.props;
    const averageStarRating = summary?.averageStarRating || 0;

    let reviewBanner;
    let filtersWrapper;

    if (this.showBanner()) {
      const banner = (
        <button
          className="btn-secondary reviews-banner__button"
          onClick={this.props.triggerReviewModal}
          onKeyPress={onEnterPress(this.props.triggerReviewModal)}>
          Write a Review
        </button>
      );

      reviewBanner = (
        <div className="reviews-banner">
          {banner}
          <div className="cta-content">
            <h3 className="cta-header">Got a Minute?</h3>
            <p className="cta-text">
              Share your review (upload a pic, too!) and help others select the perfect style and fit.
            </p>
          </div>
        </div>
      );
    }

    if (this.props.count) {
      const sizeMap = this.props.product?.sizeScale?.sizeNames || getSizeMap(product?.skus || []);
      const sizes = this.props.product?.sizes || Object.keys(sizeMap);
      filtersWrapper = (
        <div className="filters-wrapper">
          <div className="reviews-filters">
            <label htmlFor="reviews-sort" className="eyebrow">
              Sort
            </label>
            <form className="input-wrapper">
              <select id="reviews-sort" className="py-1 px-2" onChange={this.props.sortReviews} value={this.props.sort}>
                {this.filters.map(filter => {
                  return (
                    <option key={filter.value} value={filter.value}>
                      {filter.label}
                    </option>
                  );
                })}
              </select>
            </form>
          </div>
          {Array.isArray(sizes) && sizes?.length > 1 && (
            <SizeFilter
              applySelectedStyles={selectedSizes => this.props.filterReviewsBySize(selectedSizes)}
              selectedSizes={this.props.selectedSizes}
              sizeNames={sizeMap}
              sizes={sizes}
            />
          )}
        </div>
      );
    }

    return (
      <div className="reviews-header__top">
        <div className="reviews-summary-content">
          {reviewBanner}
          <div className="reviews-header__title">
            <h2>
              Ratings & <br /> Reviews
            </h2>

            <div className="reviews-average-rating review">
              <div className="inline-block">
                <ReviewStars imageName={`BlackStars${Math.floor(averageStarRating)}`} /> &nbsp; ({this.props.count})
                &nbsp;
                <ToolTipIcon align="center" Icon={InfoIcon}>
                  <p> Includes written reviews and customer fit feedback.</p>
                </ToolTipIcon>
              </div>
            </div>
          </div>
          <div className="reviews-header__fit-summary">
            {this.props.count > 0 ? <div className="dek-one">Fit</div> : null}
            <FitSummary fitCounts={this.props?.summary?.fitCounts} />
          </div>

          <div className="flex flex-col w-1/3">
            {this.props.reviewsThumbnailPhotos?.length > 0 && (
              <p className="text-md font-semibold uppercase tracking-widest">All Photos</p>
            )}
            <ReviewThumbNailCarousel productId={product?.id || product?.productId} />
          </div>
        </div>
        {filtersWrapper}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  reviewsThumbnailPhotos: state.reviewsThumbnailPhotos?.moments ?? [],
});

export default compose(withUserData, withUserReviewSummary(), connect(mapStateToProps, null))(ReviewsHeaderComponent);
